import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizMenu',
  setup(__props) {

const route = useRoute();
const router = useRouter();

function showQuestions() {
  router.push('/co2quiz');
}
function showValues() {
  router.push('/co2quiz/values');
}
function showAverages() {
  router.push('/co2quiz/averages');
}

const items = computed(() => {
  if (route.path === '/co2quiz') {
    return ['CO₂ Quiz', 'Questions'];
  } else if (route.path === '/co2quiz/values') {
    return [
      {
        title: 'CO₂ Quiz',
        href: '/co2quiz',
      },
      'Values',
    ];
  }
  return [
    {
      title: 'CO₂ Quiz',
      href: '/co2quiz',
    },
    'Averages',
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, { items: items.value }, null, 8, ["items"]),
      (_unref(route).path !== '/co2quiz')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            flat: "",
            color: "info",
            onClick: showQuestions
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Questions")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/co2quiz/values')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            flat: "",
            color: "info",
            onClick: showValues
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Values")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/co2quiz/averages')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            flat: "",
            color: "info",
            onClick: showAverages
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Averages")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})